import {
  DefaultConfigBuilderContext,
  PresentationType,
  SectionViewBuilderContext,
  SectionWidget,
} from "../section-widget";
import { FreeHtmlTextSectionConfig } from "./free-html-text-section-config";
import { FreeHtmlTextSectionView } from "./free-html-text-section-view";
import { filterXSS, IFilterXSSOptions } from "xss";
import { v4 as uuidv4 } from "uuid";

export const freeHtmlTextSectionFilterOptions: IFilterXSSOptions = {
  whiteList: {
    h1: ["style"],
    h2: ["style"],
    h3: ["style"],
    h4: ["style"],
    h5: ["style"],
    h6: ["style"],
    b: ["style"],
    p: ["style"],
    div: ["style"],
    strong: ["style"],
    em: ["style"],
    a: ["href", "target", "rel"],
    ul: ["style"],
    ol: ["style"],
    li: ["style"],
    br: [],
    i: ["style"],
    span: ["style"],
  },
};

export class FreeHtmlTextSectionWidget
  implements
    SectionWidget<
      "free-html-text",
      FreeHtmlTextSectionConfig,
      FreeHtmlTextSectionView
    >
{
  type: "free-html-text" = "free-html-text" as const;

  supportedPresentationTypes: PresentationType[] = [
    "cma",
    "general-presentation",
  ];

  buildDefaultConfig(
    _: DefaultConfigBuilderContext
  ): FreeHtmlTextSectionConfig {
    return {
      type: "free-html-text",
      navTitle: "Free Text",
      id: uuidv4(),
      visibility: true,
      title: "Untitled Section",
      htmlContent: `<h5 style="text-align:center;">Untitled Section</h5><p style="text-align:center;">This is the new free text section.</p>`,
    };
  }

  sanitizeSectionConfig(
    sectionConfig: FreeHtmlTextSectionConfig
  ): FreeHtmlTextSectionConfig {
    const { htmlContent } = sectionConfig;
    const sanitizedHtmlContent = filterXSS(
      htmlContent,
      freeHtmlTextSectionFilterOptions
    );
    return { ...sectionConfig, htmlContent: sanitizedHtmlContent };
  }

  buildView({
    sectionConfig: config,
  }: SectionViewBuilderContext<
    FreeHtmlTextSectionConfig,
    null
  >): FreeHtmlTextSectionView {
    if (config.type !== "free-html-text")
      throw new Error("Unexpected section type.");
    const { id, type, visibility, htmlContent, title, navTitle } = config;
    const view: FreeHtmlTextSectionView = {
      id,
      type,
      visibility,
      htmlContent,
      title,
      navTitle,
    };
    return view;
  }
}
